function handleDismiss(cmp) {
    const e = cmp.dismiss.emit();
    if (!e.defaultPrevented) {
        cmp.el.remove();
    }
}

export { handleDismiss as h };

//# sourceMappingURL=index2.js.map